import { Backdrop, Button, CircularProgress, Container, TextField, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { Context } from "../../App";

export default function UserCompteForm({onLogin}) {
    const { setIsConnected, setUserId } = React.useContext(Context);
    const [loading, setLoading] = React.useState(false);

    const [genre, setGenre] = React.useState('Mr');
    const [nom, setNom] = React.useState('');
    const [prenom, setPrenom] = React.useState('');
    const [mail, setMail] = React.useState('');
    const [tel, setTel] = React.useState('');
    const [voie, setVoie] = React.useState('');
    const [zip_code, setZipCode] = React.useState('');
    const [ville, setVille] = React.useState('');
    const [adresse_complement, setAdresseComplement] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');

    const [passwordError, setPasswordError] = React.useState('');
    const [msg, setMsg] = React.useState('');

    async function handleSubmit(e) {
        e.preventDefault();
        if(password.length < 8) {
            setPasswordError('Le mot de passe doit contenir au moins 8 caractères');
            return;
        } else if (password !== confirmPassword) {
            setPasswordError('Les mots de passe ne correspondent pas');
            return;
        } else {
            setPasswordError('');
            setLoading(true);

            fetch(`${process.env.REACT_APP_API_URL}/user`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('anonUserId') || ''}`
                },
                body: JSON.stringify({
                    genre,
                    nom,
                    prenom,
                    mail,
                    tel,
                    voie,
                    zip_code,
                    ville,
                    adresse_complement,
                    mdp: password
                }),
            })
            .then(async response => {
                if (!response.ok) {
                    const text = await response.text();
                    setMsg((response.status!==500 ? text : null) || 'Erreur lors de l\'enregistrement');
                }else {
                    localStorage.setItem('token', response.headers.get('x-auth-token'));
                    const json = await response.json();
                    localStorage.setItem('user', json._id);
                    setUserId(json._id);
                    setIsConnected(true);
                    setMsg('');
                    onLogin()
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                console.error('Erreur lors de l\'inscription :', error);
                alert('Une erreur est survenue. Veuillez réessayer plus tard.');
            });
        }
    }

    return <Container component='form' onSubmit={handleSubmit} maxWidth="sm" sx={{ display:'flex', flexDirection:'column', mt: {xs: 2, sm: 4}, rowGap:2, minWidth: { xs: 'auto', sm: '400px' }, px: { xs: 0, sm: 3 } }}>
   <Typography variant="h4" align="center" sx={{ mb: 2, fontSize: { xs: '1.75rem', sm: '2.125rem' } }}>Je m'inscris</Typography>

   {msg && <Typography variant="body1" color="error" sx={{ mb: 2, fontSize: { xs: '0.875rem', sm: '1rem' } }}>{msg}</Typography>}

   <TextField fullWidth select label="Civilité" variant="outlined" value={genre} required onChange={(e) => setGenre(e.target.value)} slotProps={{ select: {native: true} }}>
       <option value="Mme">Madame</option>
       <option value="Mr">Monsieur</option>
   </TextField>

   <TextField fullWidth label="Nom" variant="outlined" value={nom} required onChange={(e) => setNom(e.target.value)} />
   <TextField fullWidth label="Prénoms" variant="outlined" value={prenom} required onChange={(e) => setPrenom(e.target.value)} />

   <TextField fullWidth label="Adresse e-mail" variant="outlined" value={mail} required type="email" onChange={(e) => setMail(e.target.value)} />

   <TextField fullWidth type="tel" label="GSM" variant="outlined" value={tel} onChange={(e) => setTel(e.target.value)} />

   <Typography variant="h6" sx={{ mt: 2, fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>Adresse</Typography>
   <TextField fullWidth label="Numéro et nom de la voie" variant="outlined" value={voie} onChange={(e) => setVoie(e.target.value)} sx={{ mb: 2 }} />
   <TextField fullWidth label="Complément d'adresse" variant="outlined" value={adresse_complement} onChange={(e) => setAdresseComplement(e.target.value)} sx={{ mb: 2 }} />
   <TextField fullWidth label="Code postal" type="number" autoComplete="postal-code" variant="outlined" value={zip_code} required onChange={(e) => setZipCode(e.target.value)} sx={{ mb: 2 }} />
   <TextField fullWidth label="Ville" variant="outlined" value={ville} required onChange={(e) => setVille(e.target.value)} sx={{ mb: 2 }} />

   <Typography variant="h6" sx={{ mt: 2, fontSize: { xs: '1.1rem', sm: '1.25rem' } }}>Mot de passe</Typography>
   <TextField fullWidth type="password" label="Mot de passe" variant="outlined" required onChange={(e) => setPassword(e.target.value)} />
   <TextField fullWidth type="password" label="Confirmer le mot de passe" variant="outlined" required error={!!passwordError} helperText={passwordError} onChange={(e) => setConfirmPassword(e.target.value)} sx={{ mb: 4 }} />

   {msg && <Typography variant="body1" color="error" sx={{ my: 2, fontSize: { xs: '0.875rem', sm: '1rem' } }}>{msg}</Typography>}

   <Button variant="contained" type='submit' sx={{alignSelf: 'center', px: 5, mb: 2, py: { xs: 1.2, sm: 1.5 }, fontSize: { xs: '0.9rem', sm: '0.875rem' } }}>Enregistrer</Button>

   <Backdrop open={loading}><CircularProgress/></Backdrop>

</Container>
}